import { SET_LATEST_SCAN_TIME, SET_LATEST_K8S_SCAN_TIME } from '@root/constants/actionTypes';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useLatestScanTime = () => {
  const dispatch = useDispatch();

  const latestScanTime = useSelector(state => state.latestScanTimeReducer.latest_scan);
  const latestScanId = useSelector(state => state.latestScanTimeReducer.latest_scan_id);
  const latestK8sScanTime = useSelector(state => state.latestScanTimeReducer.latest_k8s_scan);
  const setLatestScanTime = useCallback(
    scanTime => {
      //  dispatchEvent()
      dispatch({ type: SET_LATEST_SCAN_TIME, payload: scanTime });
    },
    [dispatch],
  );
  const setLatestK8sScanTime = useCallback(
    scanTime => {
      dispatch({ type: SET_LATEST_K8S_SCAN_TIME, payload: scanTime });
    },
    [dispatch],
  );
  return { latestScanTime, latestScanId, setLatestScanTime, setLatestK8sScanTime, latestK8sScanTime };
};

export default useLatestScanTime;
